import Vue from 'vue'
import { makeQueryStringDync, errorServeiceHandler, makeQueryFormDataDyn } from '../helper'
const state = {
    stbData: undefined,
    smcData: undefined
};

const getters = {
    getStbData: (state) => {
        return state.stbData;
    },
    getSmcData: (state) => {
        return state.smcData;
    }
};

const mutations = {
    setStbData: (state, data) => {
        state.stbData = data;
    },
    setSmcData: (state, data) => {
        state.smcData = data;
    }
};

const actions = {

    actPostRetrack: (context, payload) => {
        console.log("actPostRetrack module check")
        return new Promise((resolve, reject) => {
            if (!payload) {
                reject({ error: "payload not found" });
            }
            console.log(payload);
            let data = makeQueryFormDataDyn(payload);
           fetch(context.getters.baseUrl + '/lco/v1/hardware/retrack', {
            method: 'POST',
            body: data
           })
           .then(errorServeiceHandler)
           .then((response) => {
                return response.json()    
           }).then((data) => {
                resolve(data)
            }).catch((error) => {
                reject(error)
            });
        });
    },
    actGetDeviceDeatils: (context, payload) => {
        return new Promise((resolve, reject) => {
            if (!payload) {
                reject({ error: "payload not found" });
            }

            let dataObj = {};
            let queryStr = ''
            dataObj = {
                'customerno': payload.replacenum
            }

            queryStr = makeQueryStringDync(dataObj);

            fetch(context.getters.baseUrl + '/lco/v1/hardware/getdevicedetails' + queryStr, {
                method: 'GET'
            })
                .then(errorServeiceHandler)
                .then((response) => {
                    return response.json()
                }).then((data) => {                  
                    resolve(data)
                }).catch((error) => {
                    if(context.getters.getMode == "development") {
                    resolve({"castype":"CLK","stbno":"214121642536673","stbitemcode":"MSTBNG01","entityid":"FR5125","customercan":"20788451","smcno":"030080342527","smcitemcode":"MSMC01"})
                       return
                    }
                    reject(error);
                });
        });
    },
    actPostReplacement: (context, payload) => {
        return new Promise((resolve, reject) => {
            if (!payload) {
                reject({ error: "payload not found" });
            }
            let data = makeQueryFormDataDyn(payload);
           fetch(context.getters.baseUrl + '/lco/v1/hardware/swap', {
            method: 'POST',
            body: data
           })
           .then(errorServeiceHandler)
           .then((response) => {
                return response.json()
           }).then((data) => {
                resolve(data)  
            }).catch((error) => {
                reject(error);
            });
        });
    },
    actGetBanner: (context, payload) => {
        return new Promise((resolve, reject) => {
                if (payload.bannertype == 'BANNER') {
                    let alertBANNER = JSON.parse(localStorage.getItem('alertBANNER'))
                    if (alertBANNER) {
                        if (Object.keys(alertBANNER).length) {
                            resolve(alertBANNER)
                            return
                        }
                    }
                } else if (payload.bannertype == 'OFFER') {
                    let alertOFFERBanner = JSON.parse(localStorage.getItem('alertOFFERBanner'))
                    if (alertOFFERBanner) {
                        if (Object.keys(alertOFFERBanner).length) {
                            resolve(alertOFFERBanner)
                            return
                        }
                    }
                } else if (payload.bannertype == 'NXTUDAAN') {
                    let alertNXTUDAANBanner = JSON.parse(localStorage.getItem('alertNXTUDAANBanner'))
                    if (alertNXTUDAANBanner) {
                        if (Object.keys(alertNXTUDAANBanner).length) {
                            resolve(alertNXTUDAANBanner)
                            return
                        }
                    }
                } else if (payload.bannertype == 'SAL') {
                    let alertSALBanner = JSON.parse(localStorage.getItem('alertSALBanner'))
                    if (alertSALBanner) {
                        if (Object.keys(alertSALBanner).length) {
                            resolve(alertSALBanner)
                            return
                        }
                    }
                }
          
            if (!payload) {
                reject({ error: "payload not found" });
            }
            let dataObj = {};
            let queryStr = ''
            dataObj = {
                'bannertype': payload.bannertype,
                'page': '1'
            }
            queryStr = makeQueryStringDync(dataObj);
            fetch(context.getters.baseUrl + '/lco/v1/banner' + queryStr, {
            method: 'GET'
           })
           .then(errorServeiceHandler)
           .then((response) => {
                return response.json()
            }).then((data) => {
                if (payload.bannertype == 'BANNER') {
                    localStorage.setItem("alertBANNER",JSON.stringify(data))
                } else if (payload.bannertype == 'OFFER') {
                    localStorage.setItem("alertOFFERBanner",JSON.stringify(data))
                } else if (payload.bannertype == 'NXTUDAAN') {
                    localStorage.setItem("alertNXTUDAANBanner",JSON.stringify(data))
                } else if (payload.bannertype == 'SAL') {
                    localStorage.setItem("alertSALBanner",JSON.stringify(data))
                }
                resolve(data)   
            }).catch((error) => {
                if(context.getters.getMode == "development") {
                    resolve([{"promoadsid":"31","filename":"DP5vLzUv.jpg","adtype":"BANNER","weight":"1","adstatus":"ACTIVE","created":"2020-09-14 09:17:33","url":"https:\/\/s3.ap-south-1.amazonaws.com\/com.kyc.dpcollection.incablenet.mum\/images\/promo\/DP5vLzUv.jpg"},{"promoadsid":"27","filename":"iNf87UUa.jpg","adtype":"BANNER","weight":"1","adstatus":"ACTIVE","created":"2020-07-31 10:29:53","url":"https:\/\/s3.ap-south-1.amazonaws.com\/com.kyc.dpcollection.incablenet.mum\/images\/promo\/iNf87UUa.jpg"},{"promoadsid":"28","filename":"YoDbqAIx.jpg","adtype":"BANNER","weight":"2","adstatus":"ACTIVE","created":"2020-07-31 10:30:52","url":"https:\/\/s3.ap-south-1.amazonaws.com\/com.kyc.dpcollection.incablenet.mum\/images\/promo\/YoDbqAIx.jpg"}])
                }
                reject(error);
            });
        });
    },
    actPostOsd: (context, payload) => {
        return new Promise((resolve, reject) => {
            if (!payload) {
                reject({ error: "payload not found" });
            }
            let data = makeQueryFormDataDyn(payload);
           fetch(context.getters.baseUrl + '/lco/v1/hardware/osd', {
            method: 'POST',
            body: data
           })
           .then(errorServeiceHandler)
           .then((response) => {
                return response.json()
           }).then((data) => {
                resolve(data)
            }).catch((error) => {
                reject(error)
            });
        });
    },
    getPayForBox: (context, filterData) => {
        return new Promise( (resolve, reject) => {
        let queryStr = ''
          queryStr = makeQueryStringDync(filterData)
               
          fetch(context.getters.baseUrl + '/lco/v1/lcopaymentreport/payforboxpayment' + queryStr, {
            method: 'GET'
            })
            .then(errorServeiceHandler)
            .then((response) => {
                return response.json()
              }).then((data) => {
                resolve(data)
              }).catch((error) => {
                if(context.getters.getMode == "development") {
                   resolve([{"payboxid":"6738687","boxtype":"Adaptor - 5V","quantity":"1","model":"test","comments":"test","created":"2020-07-22 15:32:57","lcoid":"h7juP6Xn","totalprice":"150.00","gateway":"PAYTM","status":"CANCELLED","boxprice":"150.00","transactionid":"20200722111212800110168813737465650"},{"payboxid":"6738662","boxtype":"Adaptor - 12V","quantity":"1","model":"test","comments":"test","created":"2020-07-22 15:29:23","lcoid":"h7juP6Xn","totalprice":"150.00","gateway":"PAYTM","status":"CANCELLED","boxprice":"150.00","transactionid":"20200722111212800110168486737092817"},{"payboxid":"6141945","boxtype":"SD_STB to HD MPEG4 STB @599","quantity":"1","model":"saa","comments":"","created":"2020-05-25 12:33:34","lcoid":"h7juP6Xn","totalprice":"599.00","gateway":"PAYTM","status":"CANCELLED","boxprice":"599.00","transactionid":"20200525111212800110168463728802254"},{"payboxid":"6112935","boxtype":"Attenuator","quantity":"1","model":"Megha Test","comments":"","created":"2020-05-21 17:35:02","lcoid":"h7juP6Xn","totalprice":"10.00","gateway":"PAYTM","status":"PAID","boxprice":"10.00","transactionid":"20200521111212800110168497428417754"},{"payboxid":"6112919","boxtype":"Attenuator","quantity":"1","model":"Megha Test","comments":"","created":"2020-05-21 17:33:42","lcoid":"h7juP6Xn","totalprice":"1.00","gateway":"PAYTM","status":"CANCELLED","boxprice":"10.00","transactionid":"20200521111212800110168079728510941"},{"payboxid":"6108001","boxtype":"Conax Set Top Box","quantity":"2","model":"tt","comments":"","created":"2020-05-21 12:53:38","lcoid":"h7juP6Xn","totalprice":"2400.00","gateway":"PAYTM","status":"CANCELLED","boxprice":"1200.00","transactionid":"20200521111212800110168707028093422"},{"payboxid":"6108000","boxtype":"Conax Set Top Box","quantity":"2","model":"tt","comments":"","created":"2020-05-21 12:53:37","lcoid":"h7juP6Xn","totalprice":"2400.00","gateway":"PAYTM","status":"CANCELLED","boxprice":"1200.00","transactionid":"20200521111212800110168711328205563"},{"payboxid":"6107997","boxtype":"Adaptor - 12V","quantity":"100","model":"1000","comments":"","created":"2020-05-21 12:53:28","lcoid":"h7juP6Xn","totalprice":"15000.00","gateway":"PAYTM","status":"CANCELLED","boxprice":"150.00","transactionid":"20200521111212800110168273928652526"},{"payboxid":"6105728","boxtype":"Attenuator","quantity":"1","model":"trai","comments":"test","created":"2020-05-21 03:26:49","lcoid":"h7juP6Xn","totalprice":"1.00","gateway":"PAYTM","status":"PAID","boxprice":"10.00","transactionid":"20200521111212800110168476727953278"},{"payboxid":"6105725","boxtype":"Attenuator","quantity":"1","model":"STB Rukmini","comments":"","created":"2020-05-21 02:51:15","lcoid":"h7juP6Xn","totalprice":"1.00","gateway":"PAYTM","status":"PAID","boxprice":"10.00","transactionid":"20200521111212800110168504728248023"},{"payboxid":"6105724","boxtype":"Attenuator","quantity":"1","model":"test","comments":"","created":"2020-05-21 02:50:58","lcoid":"h7juP6Xn","totalprice":"1.00","gateway":"PAYTM","status":"CANCELLED","boxprice":"10.00","transactionid":"20200521111212800110168512428490411"},{"payboxid":"6105719","boxtype":"Attenuator","quantity":"1","model":"STB Safiqul","comments":"For Test","created":"2020-05-21 02:38:53","lcoid":"h7juP6Xn","totalprice":"1.00","gateway":"PAYTM","status":"PAID","boxprice":"10.00","transactionid":"20200521111212800110168776428122658"},{"payboxid":"6105718","boxtype":"Attenuator","quantity":"1","model":"","comments":"for testing purpose","created":"2020-05-21 02:36:57","lcoid":"h7juP6Xn","totalprice":"1.00","gateway":"PAYTM","status":"CANCELLED","boxprice":"10.00","transactionid":"20200521111212800110168787027934157"},{"payboxid":"6105706","boxtype":"Attenuator","quantity":"1","model":"","comments":"for testing","created":"2020-05-21 02:20:43","lcoid":"h7juP6Xn","totalprice":"1.00","gateway":"PAYTM","status":"PAID","boxprice":"10.00","transactionid":"20200521111212800110168112628405611"},{"payboxid":"6105705","boxtype":"Attenuator","quantity":"1","model":"stb vaibhav","comments":"for testing","created":"2020-05-21 02:17:19","lcoid":"h7juP6Xn","totalprice":"1.00","gateway":"PAYTM","status":"PAID","boxprice":"10.00","transactionid":"20200521111212800110168123528213447"}])
                }
                reject(error);
            });
        });
    },
    getBOXTypeDetails: (context, filterData) => {
        return new Promise( (resolve, reject) => {

          fetch(context.getters.baseUrl + '/lco/v1/payment/boxprice', {
            method: 'GET'
            })
            .then(errorServeiceHandler)
            .then((response) => {
                return response.json();
              }).then((data) => {
                   resolve(data)
              }).catch((error) => {
                if (context.getters.getMode == "development") {
                   resolve([{"idboxtypeclass":"Adaptor - 12V","price":"150.00"},{"idboxtypeclass":"Adaptor - 5V","price":"150.00"},{"idboxtypeclass":"Adaptors","price":"118.00"},{"idboxtypeclass":"Attenuator","price":"10.00"},{"idboxtypeclass":"AV Chord 1 by 3","price":"125.00"},{"idboxtypeclass":"AV Chord 3 by 3","price":"60.00"},{"idboxtypeclass":"Conax HD Set Top Box","price":"1550.00"},{"idboxtypeclass":"Conax JV Set Top Box","price":"1200.00"},{"idboxtypeclass":"Conax Set Top Box","price":"1200.00"},{"idboxtypeclass":"HD 8120 FESTIVAL DHAMAKA","price":"1149.00"},{"idboxtypeclass":"HD 8120 FESTIVAL DHAMAKA - JV","price":"1600.00"},{"idboxtypeclass":"HD Hybrid Festival Dhamaka","price":"1249.00"},{"idboxtypeclass":"HD Hybrid Festival Dhamaka - J","price":"1700.00"},{"idboxtypeclass":"HDMI Cable","price":"125.00"},{"idboxtypeclass":"Merlin Embedded Card STB","price":"399.00"},{"idboxtypeclass":"Merlin Embedded Card STB - JV","price":"799.00"},{"idboxtypeclass":"NSTV Embedded MPEG4 HD HYBRID","price":"1250.00"},{"idboxtypeclass":"NSTV OVT Embedded MPEG4 SD","price":"399.00"},{"idboxtypeclass":"NSTV OVT Embedded MPEG4 SD - J","price":"450.00"},{"idboxtypeclass":"Refurbish MPEG4 MERLIN","price":"350.00"},{"idboxtypeclass":"Refurbished STB MPEG4 @ 350","price":"350.00"},{"idboxtypeclass":"Remote Type I - SD","price":"50.00"},{"idboxtypeclass":"Remote Type II - HD","price":"125.00"},{"idboxtypeclass":"Remotes","price":"118.00"},{"idboxtypeclass":"Replacement Hardware MPEG4 HD to MPEG4 HD HYBRID","price":"999.00"},{"idboxtypeclass":"Replacement Hardware MPEG4 SD to MPEG4 HD (CH8120)","price":"950.00"},{"idboxtypeclass":"Replacement Hardware SD to HD HYBRID FR STB @599","price":"599.00"},{"idboxtypeclass":"Replacement HD to MPEG4 HD-995","price":"995.00"},{"idboxtypeclass":"Replacement Lightning MerlinMPEG4 SD Embedded WithOut Warranty","price":"700.00"},{"idboxtypeclass":"Replacement Package Merlin Cardless WithOut Warranty 200","price":"226.00"},{"idboxtypeclass":"Replacement Package Merlin With Card WithOut Warranty 1125","price":"625.00"},{"idboxtypeclass":"Replacement Package MerlinMPEG4 HD Embedded WithOut Warranty","price":"505.00"},{"idboxtypeclass":"Replacement Package MPEG2 To MPEG4","price":"500.00"},{"idboxtypeclass":"SD_STB to HD HYBRID STB @599","price":"599.00"},{"idboxtypeclass":"SD_STB to HD MPEG4 STB @599","price":"599.00"},{"idboxtypeclass":"SD_STB TO OVT@ 399 PAN INDIA","price":"399.00"},{"idboxtypeclass":"SD_STB@399 PAN_INDIA","price":"399.00"}])
                   return
                }
                reject(error);
            });
        });
    },
    paymentforPayBoxDetails: (context, payload) => {
        return new Promise((resolve, reject) => {
            if (!payload) {
                reject({ error: "payload not found" });
            }
            let data = makeQueryFormDataDyn(payload);
           fetch(context.getters.baseUrl + '/lco/v1/payment/payforbox', {
            method: 'POST',
            body: data
           })
           .then(errorServeiceHandler)
           .then((response) => {
                return response.json()
           }).then((data) => {
                resolve(data)
            }).catch((error) => {
                reject(error)
            });
        });
    },
    actSendSms: (context, payload) => {
        return new Promise((resolve, reject) => {
            if (!payload) {
                reject({ error: "payload not found" });
            }
            let data = makeQueryFormDataDyn(payload);
           fetch(context.getters.baseUrl + '/lco/v1/sendsms', {
            method: 'POST',
            body: data
           })
           .then(errorServeiceHandler)
           .then((response) => {
                return response.json()
           }).then((data) => {
                resolve(data)
            }).catch((error) => {
                reject(error)
            });
        });
    },
    sendAndriodRequest: (context, payload) => {
        return new Promise((resolve, reject) => {
            if (!payload) {
                reject({ error: "payload not found" });
            }
            let data = makeQueryFormDataDyn(payload);
            fetch(context.getters.baseUrl + '/lco/v1/hardware/hwreplacement', {
                method: 'POST',
                body: data
            })
            .then(errorServeiceHandler)
            .then((response) => {
                    return response.json()    
            }).then((data) => {
                resolve(data)
            }).catch((error) => {
                reject(error)
            });
        });
    },
};

export default {
    state, getters, mutations, actions
};


// WEBPACK FOOTER //
// ./src/store/modules/deviceModule.js